import { configureStore } from "@reduxjs/toolkit";

import feedbackReducer from "../states/reducers/feedbackReducer";
import statsticsReducer from "../states/reducers/statsticsReducer";
import userReducer from "../states/reducers/userReducer";
import dataReducer from "../states/reducers/dataSilence";
import loginReducer from "../states/reducers/logingReducer";
import newsReducer from "../states/reducers/newsReducer";
import googleResponseReducer from "../states/reducers/googleResponseReducer";
import teamsReducer from "../states/reducers/teamsReducer";
import testimonialReducer from "../states/reducers/testimonialsReducer";
import partnersReducer from "../states/reducers/partnersReducer";
import appointmentReducer from "../states/reducers/appointmentReducer";

const store = configureStore({
  reducer: {
    feedback: feedbackReducer,
    statstics: statsticsReducer,
    users: userReducer,
    data: dataReducer,
    userLogin: loginReducer,
    blogs: newsReducer,
    googleformresponse: googleResponseReducer,
    teams: teamsReducer,
    testimonials: testimonialReducer,
    partners: partnersReducer,
    appointment: appointmentReducer,
  },
});

export default store;
